import type { ReactNode } from "react";

import { CheckIcon, ErrorIcon, WarningIcon } from "@/components/icons";
import { cn } from "@/lib/utils";

// DESIGN.md components: alert-error, alert-warning, alert-success.
// Plain words; an icon plus text, never color alone.
const STYLES = {
  error: { cls: "bg-zsd-error text-zsd-on-error", Icon: ErrorIcon, role: "alert" },
  warning: { cls: "bg-zsd-warning text-zsd-on-warning", Icon: WarningIcon, role: "status" },
  success: { cls: "bg-zsd-success text-zsd-on-success", Icon: CheckIcon, role: "status" },
} as const;

export function Alert({ tone, children, className }: { tone: keyof typeof STYLES; children: ReactNode; className?: string }) {
  const { cls, Icon, role } = STYLES[tone];
  return (
    <div role={role} className={cn("rounded-zsd-sm p-zsd-lg flex gap-zsd-md items-start font-zsd-body-md text-zsd-body-md", cls, className)}>
      <Icon size={20} className="shrink-0 mt-zsd-xs" />
      <div className="min-w-0">{children}</div>
    </div>
  );
}

/** DESIGN.md component: helper-text. Not for amounts, fees or warnings. */
export function HelperText({ children, className }: { children: ReactNode; className?: string }) {
  return <p className={cn("m-0 mt-zsd-sm font-zsd-body-sm text-zsd-body-sm text-zsd-muted", className)}>{children}</p>;
}
